import { BillTableRowType } from "../../types"
import dayjs from "dayjs"
import { ReactComponent as WARNING } from "../../../../assets/WarningICON.svg"
import { formatCurrency, returnAddressString } from "../../../../services/functions"
import BaseTableRow from "../../../../components/layout/BaseTableRow"
import { useNavigate } from "react-router-dom"
import { Navigation } from "../../../../api/constants"
import { P } from "../../../../auth/permissions"
import { Authorized } from "../../../../components/authentication/Authorized"
import { useAbility } from "../../../../components/contexts/AbilityContext"

export default function BillTableRow(props: BillTableRowType) {
    const navigate = useNavigate()
    const ability = useAbility()

    const handleClickOnRow = () => {
        if (ability.can(P.buchhaltung_read.action, P.buchhaltung_read.subject)) {
            navigate(Navigation.BILL_DETAILED + props.id)
        }
    }
    
    return (
        <BaseTableRow onClick={handleClickOnRow} classProps={`${props.archived && "opacity-40 bg-gray-100"} ${props.canceled && "text-black/30"}`}>
            <td className="hidden md:table-cell">
                <p className="line-clamp-1 text-center">{props.canceled ? <p className="uppercase font-semibold">Storniert</p> : dayjs(props.date).format("DD.MM.YYYY")}</p>
            </td>
            <td>
                <p title={props.title} className="line-clamp-1 text-center">
                    Rechnung {props.title}
                </p>
            </td>
            <td className="hidden sm:table-cell">
                <p className="line-clamp-1 text-center">{props.type}</p>
            </td>
            <Authorized allOf={[P.buchhaltung_read]}>
                <td>
                    <p className="line-clamp-1  text-center">{formatCurrency(props.netto)}</p>
                </td>
                <td className="hidden xl:table-cell">
                    <p className="line-clamp-1  text-center">{formatCurrency(props.brutto)}</p>
                </td>
            </Authorized>
            <td className="table-cell">
                <p title={props.customer.name} className="line-clamp-1 flex justify-center text-center">
                    {props.customer.softDeleteAfter && (
                        <span className="pr-2">
                            <WARNING className="w-6 h-6 text-red-700" />
                        </span>
                    )}
                    {props.customer.name}
                </p>
            </td>
            <td className="hidden lg:table-cell">
                <p title={returnAddressString(props.object)} className="line-clamp-1 flex justify-center text-center">
                    {props.object.softDeleteAfter && (
                        <span className="pr-2">
                            <WARNING className="w-6 h-6 text-red-700" />
                        </span>
                    )}
                    {props.object?.adress ? returnAddressString(props.object) : "keine Angabe"}
                </p>
            </td>
        </BaseTableRow>
    )
}
